// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2PDwZ","calendarButtons":"ClockData_calendarButtons__3TF3y"};